export default {
  getGuarantee: (axios, digitalCertificateId) =>
    axios.get(`/api/digitalCertificates/${digitalCertificateId}/guarantee`),
  setGuarantee: (axios, digitalCertificateId, data) =>
    axios.post(
      `/api/digitalCertificates/${digitalCertificateId}/guarantee`,
      data,
    ),
}
